import React, { Component } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Collapse } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

class CollapseCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: (this.props.open !== undefined) ? this.props.open : true,
            title: (this.props.title !== undefined) ? this.props.title : ''
        }
    }

    showHide(element) {
        this.setState({
            open: !this.state.open
        })
    }

    render() {
        return (
            <Card className="mb-4">
                <CardHeader onClick={() => this.showHide()}>
                    <Row className="align-items-center">
                        <Col xs="10" className="text-left">
                            <h4>{this.state.title}</h4>
                        </Col>
                        <Col xs="2" className="text-right">
                            {(this.state.open) ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
                        </Col>
                    </Row>
                </CardHeader>
                <Collapse isOpen={this.state.open}>
                    <CardBody>
                        {this.props.children}
                    </CardBody>
                </Collapse>
            </Card>
        )
    }
};

export default CollapseCard;